export const blockIconsTravelSmokeFreeNew = (
	<span className='material-symbols-outlined'>smoke_free</span>
);
